
import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { throwError } from 'rxjs';
import { catchError, finalize } from 'rxjs/operators';
import { __await } from 'tslib';
import { Router } from '@angular/router';
import { GenericLoaderService } from '@shared/generic-loader/generic-loader.service';

export const BasicAuthInterceptor: HttpInterceptorFn = (req, next) => {

  const router = inject(Router);

  let spinnerService = inject(GenericLoaderService);

  // default setting true on api call will flase on finalize methos below
  spinnerService.showSpinner = true;

  let authReq = req.clone({
    setHeaders: {
      Authorization: `Bearer ${''}`
    }
  });

  let authToken = sessionStorage.getItem('access_token');
  let profile = JSON.parse(sessionStorage.getItem('profile'));
  let roles = sessionStorage.getItem('roles');
 

  if (authToken) {
    authReq = req.clone({
      setHeaders: {
        Authorization: `Bearer ${authToken}`,
        'X-user-roles': `${roles}`,   
        'X-user-email': `${profile.mail}`,   
        'X-user-name': `${profile.displayName}`,       
        'X-first-name': `${profile.givenName}`,
        'X-last-name': `${profile.surname}`
      }
    });
  }

  // Pass the cloned request with the updated header to the next handler
  return next(authReq).pipe(
    catchError((err: any) => {
      if (err instanceof HttpErrorResponse) {
        // Handle HTTP errors
        if (err.status === 401) {
          // Specific handling for unauthorized errors         
          console.error('Unauthorized request:', err);
          spinnerService.isErrorOccured = false;
          spinnerService.errorText = '401 server error occured';
          router.navigate(['/home/unauthorized-access'])
          // You might trigger a re-authentication flow or redirect the user here
        } else {
          // Handle other HTTP error codes
          // console.error('HTTP error: test', err);
          spinnerService.isErrorOccured = true;
          spinnerService.errorText = 'Internal server error occured';

        }
      } else {
        // Handle non-HTTP errors
        console.error('An error occurred:', err);
      }

      // Re-throw the error to propagate it further
      return throwError(() => err);
    }),
    finalize(() => {
      setTimeout(() => {
        spinnerService.showSpinner = false;
      }, 1000)
    }),
  );

};
